import api from './client';
import { Invitation, RoleType, SubscriptionPlan } from '../types';

export interface TeamInvoice {
  id: string;
  period: string;
  plan: SubscriptionPlan;
  priceNet: number;
  status: 'PENDING' | 'ISSUED' | 'FAILED';
  invoiceNumber: string | null;
  issuedAt: string | null;
}

export interface OwnBilling {
  integratorName: string;
  plan: SubscriptionPlan;
  effectivePriceNet: number | null;
  invoices: TeamInvoice[];
  /** Oczekująca prośba o zmianę planu (null = brak). */
  pendingPlanRequest: SubscriptionPlan | null;
  pendingPlanRequestedAt: string | null;
}

export const teamApi = {
  invite: (email: string, firstName?: string, lastName?: string) =>
    api.post<Invitation>('/api/team/invitations', { email, firstName, lastName }),
  inviteCustomer: (email: string, customerNip: string, firstName?: string, lastName?: string) =>
    api.post<Invitation>('/api/team/customer-invitations', { email, firstName, lastName, customerNip }),
  invitations: () => api.get<Invitation[]>('/api/team/invitations'),
  resendInvitation: (invitationId: string) =>
    api.post<Invitation>(`/api/team/invitations/${invitationId}/resend`),
  cancelInvitation: (invitationId: string) =>
    api.delete(`/api/team/invitations/${invitationId}`),
  changeRole: (userId: string, roleType: RoleType) =>
    api.put(`/api/team/members/${userId}/role`, { roleType }),
  setMemberActive: (userId: string, active: boolean) =>
    api.put(`/api/team/members/${userId}/active`, { active }),
  removeMember: (userId: string) =>
    api.delete(`/api/team/members/${userId}`),
  getNotificationEmail: () =>
    api.get<{ email: string }>('/api/team/notification-email'),
  setNotificationEmail: (email: string) =>
    api.put<{ email: string }>('/api/team/notification-email', null, { params: { email } }),
  getBilling: () => api.get<OwnBilling>('/api/team/billing'),
  requestPlanChange: (plan: SubscriptionPlan, message?: string) =>
    api.post<{ message: string }>('/api/team/billing/plan-request', { plan, message }),
};
